import { animated, config, useSpring } from '@react-spring/web';
import { memo } from 'react';

import { CheckIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { type FileStatusIconSize, fileStatusIcon, getFileStatusIconGlyphSize } from '../fileStatusIconSize';

export type FileStatusIconCompletedProps = {
  size?: FileStatusIconSize;
};

export const FileStatusIconCompleted = memo(({ size = 'default' }: FileStatusIconCompletedProps) => {
  const { container } = fileStatusIcon({ size });
  const glyphSize = getFileStatusIconGlyphSize(size);
  const [props] = useSpring(
    () => ({
      config: config.wobbly,
      from: { scale: 0 },
      to: { scale: 1 },
    }),
    [],
  );

  return (
    <div
      aria-hidden
      className={cn('flex items-center justify-center rounded-full ads:bg-ads-grass-4 bg-grass-4', container())}
    >
      <animated.div className="flex items-center justify-center" style={props}>
        <CheckIcon className="ads:text-ads-grass-11 text-grass-11" size={glyphSize} />
      </animated.div>
    </div>
  );
});

FileStatusIconCompleted.displayName = 'FileStatusIconCompleted';
